import { call, select, put } from 'redux-saga/effects';
import { FETCH_LOYALTY_REWARDS } from '../actions';
import { getRegionId } from '../../page-model/ducks/get-model';
import { fetchLoyaltyRewardsRequest } from '../api';
import { ProductLoyaltyRewardsFetchModel } from '../types/fetch-model';
import { getArticle } from '../../../common/selectors';
import { getInfo, ProductMainInfoProps } from '../../product-info';

export function* fetchLoyaltyRewards() {
  const regionId: string = yield select(getRegionId);
  const productId: string = yield select(getArticle);
  const productInfo: ProductMainInfoProps = yield select(getInfo);
  const isMarketplaceProduct = productInfo?.source?.toUpperCase() === 'PIM';

  if (!isMarketplaceProduct) {
    const loyaltyRewardsBody: ProductLoyaltyRewardsFetchModel.ILoyaltyRewardsRequest = {
      regionId,
      productBUReferences: [productId],
    };
    try {
      const result: ProductLoyaltyRewardsFetchModel.ILoyaltyRewardsResponse = yield call(
        fetchLoyaltyRewardsRequest,
        loyaltyRewardsBody,
      );

      if (result?.loyaltyRewards.length) {
        yield put(FETCH_LOYALTY_REWARDS.success(result.loyaltyRewards[0]));
      }
    } catch (err) {
      const error = err as Error;
      yield put(FETCH_LOYALTY_REWARDS.failure(error));
    }
  }
}
